import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import clsx from "clsx";

import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";

import { InputText } from "primereact/inputtext";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";

interface Props {
  regex: string;
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  icon: {
    fontSize: "1.5em",
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(2),
  },
  success: {
    color: theme.palette.success.main,
  },
  error: {
    color: theme.palette.error.main,
  },
}));

export function RegexMatchTester(props: Props) {
  const { t } = useTranslation();
  const classes = useStyles();

  const [testerTextFieldValue, setTesterTextFieldValue] = useState("");

  const [regexMatchesTestValue, setRegexMatchesTestValue] = useState(false);

  useEffect(() => {
    try {
      const r = new RegExp(props.regex);
      setRegexMatchesTestValue(r.test(testerTextFieldValue));
    } catch {
      setRegexMatchesTestValue(false);
    }
  }, [props.regex, testerTextFieldValue]);

  return (
    <div className={classes.root}>
      <InputText value={testerTextFieldValue} onChange={(e) => setTesterTextFieldValue(e.target.value)} />
      {testerTextFieldValue && (
        <>
          <FontAwesomeIcon
            icon={regexMatchesTestValue ? faCheckCircle : faExclamationCircle}
            className={clsx(classes.icon, {
              [classes.success]: regexMatchesTestValue,
              [classes.error]: !regexMatchesTestValue,
            })}
          />
          <Typography variant="overline" noWrap>
            {regexMatchesTestValue ? t("common.valid") : t("common.invalid")}
          </Typography>
        </>
      )}
    </div>
  );
}
